import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyTitle,
} from '@design-system/empty';
import type { EmptyStatePresentation } from '../../types/presentation.types';

export function AgentEmptyState({ block }: { block: EmptyStatePresentation }) {
  return (
    <Empty className='w-full max-w-full border py-8'>
      <EmptyHeader>
        <EmptyTitle className='text-sm'>{block.title}</EmptyTitle>
        <EmptyDescription>{block.message}</EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
}
